import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Container, Row, Col } from "reactstrap"
import CardParametroAnio from './CardParametroAnio';

import "../../../../assets/scss/Horas Extras/ParametrosHorasExtras.scss"
import ParametrosHorasExtrasContextProvider, { useParametrosHorasExtrasContext } from 'Context/ParametrosHorasExtrasContext';
import CardParametrosFechas from './ParametrosProyeccion/CardParametrosFechas';
import { ConsultarDetalleParametrosAnio, CrearParametrosPeriodoAnio, ActualizarParametrosPeriodoProyeccionHE, ObtenerInformacionGeneralParametrosHorasExtras } from './FunctionsParametrosHE';
import { DetalleParametrosProyeccionHE, DetalleParametrosRegimenProyeccionHE, InformacionGeneralParametrosHorasExtras } from './TypesParametrosHorasExtras';
import { alertService } from 'components/Varios/alert_service';
import Cargando from 'components/Varios/Cargando';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import ModalCargando from 'components/Varios/ModalCargando';
import { PruebaSolucion2 } from 'functions/DatesFunctions';
import CardHoras from './ParametrosProyeccion/Parametros Horas/CardHoras';
import CardPresupuestoHorasExtras from './ParametrosProyeccion/CardPresupuestoHorasExtras';
import CardPresupuestoAnualHE from './ParametrosProyeccion/CardPresupuestoAnualHE';
import CardPeriodosProyeccionHE from './ParametrosProyeccion/CardPeriodosProyeccionHE';
import ParametrosProyeccion from './ParametrosProyeccion/ParametrosProyeccion';
import CardAnioEjecucion from './CardAnioEjecucion';
import ParametrosPlanificacion from './ParametrosProyeccion/ParametrosPlanificacion';
import { SelectCombo } from 'components/Types/GeneralTypes';
import { showAlert } from './Actividades/ActividadesHorasExtras';

export function HayParametrosHEDeAnio(detallesParametros: DetalleParametrosProyeccionHE | null) {
    if (detallesParametros === null) {
        return false;
    }
    else {
        const { fechafinasigpresupGPE, fechafinproyeccion, fechainicioasigpresupGPE, fechainicioproyeccion, listadoparametroshorasregimen, presupuestoAnualHE } = detallesParametros;
        return (fechainicioproyeccion !== null && fechafinproyeccion !== null) || (fechainicioasigpresupGPE !== null && fechafinasigpresupGPE !== null) || listadoparametroshorasregimen.length > 0 || presupuestoAnualHE != null

    }
}

function MapearListadoAniosOpciones(anios: number[] | undefined) {

    if (anios === undefined) {
        return []
    }

    const opcionesCombo: SelectCombo[] = anios.map((v) => {
        return {
            label: v.toString(),
            value: v.toString()
        }
    })

    return opcionesCombo
}





export default function NewParametrosProyeccion() {



    const [informacionGeneralParametros, setinformacionGeneralParametros] = useState<InformacionGeneralParametrosHorasExtras | null>(null);
    const [loading, setloading] = useState<boolean>(false)

    const { anioParametrosSeleccionado,
        setanioParametrosSeleccionado,
        creandoParametros,
        setcreandoParametros,
        setguardandoParametro,
        parametrosHorasRegimen,
        setparametrosHorasRegimen,

    } = useParametrosHorasExtrasContext();



    async function ObtenerInformacionGeneral() {
        setloading(true)
        const informacionGeneral = await ObtenerInformacionGeneralParametrosHorasExtras("PR");
        if (informacionGeneral.status === 200 && informacionGeneral.dataResponse) {

            setinformacionGeneralParametros(informacionGeneral.dataResponse)
            
            //Para cambiar el valor de los Horas Regimen en el state
            if (informacionGeneral.dataResponse.parametrosProyeccion) {
                setparametrosHorasRegimen(informacionGeneral.dataResponse.parametrosProyeccion.listadoparametroshorasregimen)
            }            
            else {
                setparametrosHorasRegimen(null)
            }
            //

        }
        else if(informacionGeneral.status === 401){
            showAlert("Su usuario no se encuentra autorizado para verificar la información", false)
        }
        //No hay contenido, es null la informacion
        else {
            alertService.error(informacionGeneral.errorMessage);
        }
        setloading(false)
    }

    async function ConsultarDetalle(anioSeleccionado: number) {
        setloading(true)
        const detalleParametros = await ConsultarDetalleParametrosAnio(anioSeleccionado);
        if (detalleParametros.status === 200 && detalleParametros.dataResponse) {
            setinformacionGeneralParametros(detalleParametros.dataResponse)
            //Para cambiar el valor de los Horas Regimen en el state
            if (detalleParametros.dataResponse.parametrosProyeccion) {
                setparametrosHorasRegimen(detalleParametros.dataResponse.parametrosProyeccion.listadoparametroshorasregimen)
            }            
            else {
                setparametrosHorasRegimen(null)
            }
            //
        }
        else if(detalleParametros.status === 401){
            showAlert("Su usuario no se encuentra autorizado para verificar la información", false)
        }
        else {
            alertService.error(detalleParametros.errorMessage);
        }
        setloading(false)
    }









    useEffect(() => {
        ObtenerInformacionGeneral()
    }, [])




    useEffect(() => {
        if (informacionGeneralParametros !== null && informacionGeneralParametros.anio !== null) {
            setanioParametrosSeleccionado(informacionGeneralParametros.anio)
        }
    }, [informacionGeneralParametros?.anio])




    var anioParametrosDeProyeccion = informacionGeneralParametros?.anio;

    if (informacionGeneralParametros && informacionGeneralParametros.parametrosProyeccion && informacionGeneralParametros.parametrosProyeccion.anio) {
        anioParametrosDeProyeccion = informacionGeneralParametros.parametrosProyeccion.anio
    }
    else if (informacionGeneralParametros && !informacionGeneralParametros.parametrosProyeccion) {
        anioParametrosDeProyeccion = informacionGeneralParametros.anio 
    }

    return (

        <React.Fragment>


            {loading && <Cargando />}
            {!loading && (
                <Container fluid={true}>
                    <Row>
                        <Col xl={6}>
                            <Row>
                                <Col xl={12}>
                                    <CardAnioEjecucion
                                        //anio={informacionGeneralParametros?.parametrosProyeccion?.anio}
                                        anio={anioParametrosDeProyeccion}
                                        listadoAnios={MapearListadoAniosOpciones(informacionGeneralParametros?.listadoaniosdisponibles)}
                                        onChangeAnio={(anio: number) => ConsultarDetalle(anio)}
                                    />

                                </Col>


                            </Row>
                            <Row>
                                <Col xl={12}>

                                </Col>
                            </Row>
                        </Col>
                        <Col xl={6}>
                            <Row>
                                <Col xl={12}>
                                    <CardPresupuestoAnualHE
                                        detalle={informacionGeneralParametros?.parametrosPresupuestoAnual}
                                        anioParametros={anioParametrosDeProyeccion}
                                        parametrosProyeccion={informacionGeneralParametros?.parametrosProyeccion}
                                    />

                                </Col>
                            </Row>
                        </Col>
                        <Col xl={12}>

                            <ParametrosProyeccion
                                parametrosProyeccion={informacionGeneralParametros?.parametrosProyeccion}
                                anioParametros={anioParametrosDeProyeccion}
                            />

                        </Col>
                       
                    </Row>
                </Container>

            )}

            <ModalCargando
                show={creandoParametros}
                textoCargando='Guardando Parámetros'
                size='md'
                onClose={() => setcreandoParametros(false)}
            />
        </React.Fragment>


    )
}
